import React from 'react';
import {observer} from "mobx-react-lite";
import intl from "react-intl-universal";
import classNames from "classnames";
import {useRootStore} from "@stores/AppStateContext";

import {RightMenuName} from "../../../stores/RootStore";

import {CloseIcon} from "../../components/icons/CloseIcon";

import {PAGES} from "../../../stores/ViewStore";

import './RightMenuHeader.css'

export const RightMenuHeader = observer(
    () => {
        const rootStore = useRootStore();
        let isRightMenuOpen = rootStore.rightMenu !== '';
        return (
            <div
                key={rootStore.currentLocale}
                className={classNames({
                    'RightMenuHeader title-medium-bold': true,
                    'RightMenu__header-animation--open': isRightMenuOpen
                })}
            >
                {getRightMenuHeader(rootStore.rightMenu as RightMenuName)}
                {isRightMenuOpen &&
                    <CloseIcon
                        className={'RightMenuHeader__icon'}
                        size={24}
                        additionalPadding={12}
                        onClick={(event) => {
                            event.stopPropagation();
                            rootStore.view.openPageByName(PAGES.DOC_EDIT, rootStore.view.pathParams, {});
                            rootStore.setRightMenu('');
                        }}
                    />
                }
            </div>
        )
    }
)

export const getRightMenuHeader = (currentRightMenu: RightMenuName) => {
    switch (currentRightMenu) {
        case 'outline':
            return intl.get('outline.header').d('Outline');
        case 'comments':
            return intl.get('comments.header').d('Comments');
        case 'history':
            return intl.get('history.header').d('Version History');
        case 'activeUsers':
            return intl.get('activeUsers.header').d('Active on this page');
        case 'acknowledgement':
            return intl.get('acknowledgement.header').d('Acknowledgement status');
        default:
            return '';
    }
}
